import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProductsInCart } from '../reducks/users/selectors'
import { makeStyles } from '@material-ui/styles'
import { CartListItem } from '../components/products'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import {
  PrimaryButton,
  SelectBox,
  SelectBoxForBillingUserCheck,
  SelectBoxForOffice,
  selectBox,
} from '../components/UIkit'
import { TextDetail } from '../components/UIkit'
import { TextInputName } from '../components/UIkit'
import { orderProduct } from '../reducks/products/operations'
import { push } from 'connected-react-router'
import LanguageIcon from '@mui/icons-material/Language'
import SelectWorker from '../components/User/SelectWorker'
import SelectWorkerA from '../components/User/SelectWorkerA'
import SelectSupplier from '../components/Supplier/SelectSupplier'
import { getdeliveryOfficesRecords } from '../functions/deliveryoffice'
import { getUserInfo } from '../reducks/users/selectors'
import {
  getUserByEmail,
  getWorkerInfoByEmail,
  getWorkersRecordsByNumber,
  getWorkersRecordsByNumberA,
} from '../functions/users'
import { resolveWorkerName } from '../functions/worker/resolveWorkerName'
import { getSuppliersRecordsByNumber } from '../functions/suppliers'
import {
  isAdministrator,
  isAuthorizedOrderUser,
  isUpperNormal,
} from '../functions/isAuth'
import { PERMISSIONS } from '../constants/permissions'
import { JumpModal } from '../components/UIkit/modal/JumpModal'
import { getDepartments } from '../reducks/department/selectors'
import { fetchdepartments } from '../reducks/department/operations'
import SelectBoxForDepartment from '../components/UIkit/SelectBoxForDepartment'
import SelectOrderUser from '../components/User/SelectOrderUser'
import { useCategoryCounts } from '../hooks/useCategoryCounts'
import { useCategoryMaster } from '../hooks/useCategoryMaster'
import { useCalcDeduction } from '../hooks/useCalcDeduction'
import { useDeductionValidation } from '../hooks/useDeductionValidation'
import { useDeductionApplied } from '../hooks/useDeductionApplied'

const useStyles = makeStyles((theme) => ({
  detailBox: {
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: 320,
    },
    [theme.breakpoints.up('md')]: {
      width: 512,
    },
  },
  orderBox: {
    border: '1px solid rgba(0,0,0,0.2)',
    borderRadius: 4,
    boxShadow: '0 4px 2px 2px rgba(0,0,0,0.2)',
    // height: 764,
    margin: '24px auto 16px auto',
    padding: 16,
    width: 288,
  },
  searchContents: {
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  languageButton: {
    marginTop: '20px',
    width: '24px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: '#757575',
  },
  check: {
    margin: 0,
    padding: 0,
  },
  alertMessage: {
    color: 'red',
    fontSize: '0.8rem',
    textAlign: 'left',
  },
  selectBox: {
    marginTop: 16,
  },
}))

const OrderConfirm = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const userInfo = useSelector(getUserInfo)

  // const isUpperNormal =
  //   userInfo.role === PERMISSIONS.ADMINISTRATOR ||
  //   userInfo.role === PERMISSIONS.HUMAN_RESOURCE_USER;
  // const selector = useSelector((state)=>state);
  const productsInCartRedux = useSelector(getProductsInCart) || []

  const [productsInCart, setProductsInCart] = useState(productsInCartRedux)
  // useEffect(() => {
  //   const updatedProducts = productsInCartRedux.map((productRedux) => {
  //     // 同じcartIdを持つproductsInCart内のアイテムを探す
  //     const existingProduct = productsInCart.find(
  //       (p) => p.cartId === productRedux.cartId
  //     );
  //     // 既存の製品に備考があれば、その備考を使用する
  //     if (existingProduct && existingProduct.remarks) {
  //       return { ...productRedux, remarks: existingProduct.remarks };
  //     } else {
  //       return productRedux;
  //     }
  //   });
  //   setProductsInCart(updatedProducts);
  // }, [productsInCartRedux]);
  // useEffect(() => {
  //   console.log("productsInCart", productsInCart);
  // }, [productsInCart]);
  useEffect(() => {
    const updatedProducts = productsInCartRedux.map((productRedux) => {
      // 同じ cartId を持つ productsInCart 内のアイテムを探す
      const existingProduct = productsInCart.find(
        (p) => p.cartId === productRedux.cartId
      )

      if (existingProduct) {
        console.log('existingProduct', existingProduct)
        // 既存の製品から特定のフィールドを保持
        return {
          ...productRedux,
          // 既存の備考があればそれを使用
          remarks: existingProduct.remarks || productRedux.remarks,
          // deduction 関連のフィールドを上書きしない
        }
      } else {
        // 対応する製品がない場合はそのまま使用
        return productRedux
      }
    })
    setProductsInCart(updatedProducts)
  }, [productsInCartRedux])
  const [orderInfo, setOrderInfo] = useState({
    login_user_uid: userInfo.uid, //ログインユーザーUID
    login_user_id: userInfo.usernumber, //ログインユーザーID
    login_user_name: userInfo.username, //ログインユーザー名
    login_user_email: userInfo.email, //ログインユーザーメールアドレス
    login_user_dep_id: userInfo.departmentid, //ログインユーザー部署番号
    login_user_dep_name: userInfo.departmentname, //ログインユーザー部署名
    login_user_role: userInfo.role, //ログインユーザー権限
    order_base_id: userInfo.order_base_id, //発注拠点番号
    order_base_name: userInfo.order_base_name, //発注拠点名
    order_department_id: userInfo.order_department_id, //発注部署番号
    order_department_name: userInfo.order_department_name, //発注部署名

    order_user_id: '', //発注担当者番号
    order_user_name: '', //発注担当者氏名
    order_user_dep_id: '', //発注担当者部署番号
    order_user_dep_name: '', //発注担当者部署名
    order_user_email: '', //発注担当者メールアドレス
    billing_user_flg: '有', //購入依頼者有・無
    billing_user_id: '', //購入依頼者番号
    billing_user_name: '', //購入依頼者氏名
    billing_user_dep_id: '', //購入依頼者部署番号
    billing_user_dep_name: '', //購入依頼者部署名

    billing_company_flg: '無', //仕入先有・無
    billing_company_id: '', //仕入先番号
    billing_company_name_full: '', //仕入先名称
    billing_company_name: '', //仕入先名称(略)

    remark_on_order: '', //注文に関する備考

    delivery_office_id: '', //納入先事業所番号
    delivery_office_name: '', //納入先事業所名
    delivery_office_address_main: '', //納入先事業所住所
    delivery_office_address_sub: '', //納入先事業所住所
    delivery_office_tell: '', //納入先事業所電話番号
    delivery_department: '', //納入先部署名
  })
  const [userid, setUserid] = useState(''),
    [role, setRole] = useState('customer'),
    [password, setPassword] = useState(''),
    [confirmPassword, setConfirmPassword] = useState(''),
    [orderEmail, setOrderEmail] = useState(''),
    [orderUsernumber, setOrderUsernumber] = useState(''),
    [orderUsername, setOrderUsername] = useState(''),
    [orderUserdepnumber, setOrderUserdepnumber] = useState(''),
    [orderUserdepname, setOrderUserdepname] = useState(''),
    [billingUsername, setBillingUsername] = useState(''),
    [billingUsernumber, setBillingUsernumber] = useState(''),
    [billingUserdepnumber, setBillingUserdepnumber] = useState(''),
    [billingUserdepname, setBillingUserdepname] = useState(''),
    [reqBillingUser, setReqBillingUser] = useState('有'),
    reqBillingUsers = [
      { id: '無', name: '無' },
      { id: '有', name: '有' },
    ],
    [billingCompanynumber, setBillingCompanynumber] = useState(''),
    [billingCompanyname, setBillingCompanyname] = useState(''),
    [billingCompanynameFull, setBillingCompanynameFull] = useState(''),
    [reqBillingCompany, setReqBillingCompany] = useState('無'),
    reqBillingCompanies = [
      { id: '無', name: '無' },
      { id: '有', name: '有' },
    ],
    [remarkOnOrder, setRemarkOnOrder] = useState(''),
    [deliveryDepartment, setDeliveryDepartment] = useState('-')

  const [deliveryOfficeinfo, setDeliveryOfficeinfo] = useState({
    id: {
      id: '',
      bid: '',
      name: '',
      address_main: '',
      address_sub: '',
      tell: '',
    },
    name: '',
  })
  const [deliveryOffices, setDeliveryOffices] = useState([])
  //負担区分の判定
  const { categoryCounts } = useCategoryCounts(
    orderInfo.billing_user_id,
    orderInfo.billing_user_name
  )
  const { categoryMaster } = useCategoryMaster(
    productsInCart,
    orderInfo.billing_user_id,
    orderInfo.billing_user_name
  )
  useCalcDeduction({
    categoryCounts,
    categoryMaster,
    productsInCart,
    setProductsInCart,
    orderInfo,
  })
  // // //デバッグ用
  // useEffect(() => {
  //   console.log(
  //     "categoryCounts",
  //     categoryCounts,
  //     "categoryMaster",
  //     categoryMaster
  //   );
  // }, [categoryCounts, categoryMaster]);

  const fetchDeliverryOffice = async () => {
    const result = await getdeliveryOfficesRecords()
    setDeliveryOffices(result)
  }
  useEffect(() => {
    fetchDeliverryOffice()
  }, [])
  useEffect(() => {
    if (deliveryOffices.length > 0) {
      const matchingIndex = deliveryOffices.findIndex((item) => {
        // console.log(item.id.name, orderInfo.order_base_name);
        return item.id.name.startsWith(orderInfo.order_base_name)
      })
      if (matchingIndex !== -1) {
        console.log(
          'matchingIndex',
          matchingIndex,
          deliveryOffices[matchingIndex]
        )
        setDeliveryOfficeinfo(deliveryOffices[matchingIndex])
      } else {
        // ヒットしなかった場合、0番目のオブジェクトをセット
        setDeliveryOfficeinfo(deliveryOffices[0])
      }
    }
  }, [deliveryOffices])

  const subtotal = useMemo(() => {
    return productsInCart.reduce(
      (sum, product) => (sum += Number(product.totalPrice)),
      0
    )
  }, [productsInCart]) //第二引数productsInCartが変わらないかぎり、再計算されない→レンダリングの節約
  const deductionSubtotal = useMemo(() => {
    return productsInCart.reduce(
      (sum, product) => (sum += Number(product.deduction_price)),
      0
    )
  }, [productsInCart])
  const shippingFee = 0
  //const shippingFee = (subtotal>=10000) ? 0: 410;
  // const tax = subtotal * 0.1;
  const tax = 0
  const total = subtotal + shippingFee + tax
  const deductionTotal = deductionSubtotal + shippingFee + tax
  const [isPaymentClicked, setIsPaymentClicked] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  // 注文確定。入力検証・控除の再確認・注文作成(トランザクション)はorderProduct側に
  // 集約されているため、ここでは多重送信ガードのみを行う。
  const order = useCallback(async () => {
    if (isSubmitting) return
    setIsSubmitting(true)
    // 注文処理によるカート消失(リスナー反映)での自動リダイレクトを抑止する
    setIsPaymentClicked(true)
    // orderProductは注文完了画面へ遷移したときtrueを返す
    const didNavigate = await dispatch(
      orderProduct(productsInCart, total, orderInfo, deductionTotal)
    )
    if (!didNavigate) {
      // 画面に留まる場合のみ元に戻す(遷移時はアンマウントされるため不要)
      setIsPaymentClicked(false)
      setIsSubmitting(false)
    }
  }, [isSubmitting, productsInCart, total, orderInfo, deductionTotal, dispatch])

  //Input要素のイベント発火
  const inputOrderInfo = useCallback(
    (e) => {
      setOrderInfo((prevState) => {
        if (e.target.name === 'order_user_id') {
          const updatedState = {
            ...prevState,
            [e.target.name]: e.target.value,
            ['order_user_name']: '',
            ['order_user_dep_id']: '',
            ['order_user_dep_name']: '',
            ['order_user_email']: '',
          }
          setOrderUsernumber(e.target.value)
          setOrderUsername('')
          setOrderUserdepnumber('')
          setOrderUserdepname('')
          setOrderEmail('')
          return updatedState
        }
        if (e.target.name === 'billing_user_id') {
          const updatedState = {
            ...prevState,
            [e.target.name]: e.target.value,
            ['billing_user_name']: '',
            ['billing_user_dep_id']: '',
            ['billing_user_dep_name']: '',
          }
          setBillingUsernumber(e.target.value)
          setBillingUsername('')
          setBillingUserdepnumber('')
          setBillingUserdepname('')
          return updatedState
        }
        if (e.target.name === 'billing_company_id') {
          const updatedState = {
            ...prevState,
            [e.target.name]: e.target.value,
            ['billing_company_name']: '',
            ['billing_company_name_full']: '',
          }
          setBillingCompanynumber(e.target.value)
          setBillingCompanyname('')
          setBillingCompanynameFull('')
          return updatedState
        }
        if (e.target.name === 'remark_on_order') {
          const updatedState = {
            ...prevState,
            [e.target.name]: e.target.value,
          }
          setRemarkOnOrder(e.target.value)
          return updatedState
        }
        //useEffectで個別に更新する
        // if (e.target.name === "delivery_department") {
        //   const updatedState = {
        //     ...prevState,
        //     [e.target.name]: e.target.value,
        //   };
        //   setDeliveryDepartment(e.target.value);
        //   return updatedState;
        // }

        const updatedState = { ...prevState, [e.target.name]: e.target.value }
        return updatedState
      })
    },
    [setOrderInfo, productsInCart]
  )
  //セレクトボックスの変更
  useEffect(() => {
    setBillingCompanynumber('')
    setBillingCompanyname('')
    setBillingCompanynameFull('')
    // setRemarkOnOrder("");
    if (reqBillingCompany === '有') setReqBillingUser('無')
    if (
      !isUpperNormal(userInfo.role) &&
      reqBillingCompany === '無' &&
      reqBillingUser === '無'
    ) {
      setReqBillingUser('有')
    }
    setBillingUsernumber('')
  }, [reqBillingCompany])
  useEffect(() => {
    setBillingUsernumber('')
    setBillingUsername('')
    setBillingUserdepnumber('')
    setBillingUserdepname('')
    // setRemarkOnOrder("");
    if (reqBillingUser === '有') setReqBillingCompany('無')
    if (
      !isUpperNormal(userInfo.role) &&
      reqBillingCompany === '無' &&
      reqBillingUser === '無'
    ) {
      setReqBillingCompany('有')
    }
    setBillingCompanynumber('')
  }, [reqBillingUser])

  // 製品がカートにない場合はリダイレクトする
  useEffect(() => {
    if (productsInCart.length === 0 && !isPaymentClicked) {
      dispatch(push('/'))
    }
  }, [productsInCart, dispatch])

  //備考を更新する
  const updateProductItem = useCallback(
    (cartId, newRemarks, newQuantity, newTotalPrice) => {
      setProductsInCart((currentProducts) => {
        return currentProducts.map((product) => {
          if (product.cartId === cartId) {
            return {
              ...product,
              remarks: newRemarks,
              quantity: newQuantity,
              totalPrice: newTotalPrice,
            }
          }
          return product
        })
      })
    },
    [setProductsInCart]
  )

  //納入先部署の表示文字列の制御

  //ダイアログ表示の状態変数
  const [showSelectOrderUser, setShowSelectOrderUser] = useState(false)
  const handleOrderUserButtonClick = () => {
    setShowSelectOrderUser(true)
  }
  const [showSelectBillingUser, setShowSelectBillingUser] = useState(false)
  const handleBillingUserButtonClick = () => {
    setShowSelectBillingUser(true)
  }
  const [showSelectBillingCompany, setShowSelectBillingCompany] =
    useState(false)
  const handleBillingCompanyButtonClick = () => {
    setShowSelectBillingCompany(true)
  }
  useEffect(() => {
    setOrderInfo((prevState) => {
      const updatedState = {
        ...prevState,
        ['order_user_id']: orderUsernumber, //発注担当者番号
        ['order_user_name']: orderUsername, //発注担当者名
        ['order_user_dep_id']: orderUserdepnumber, //発注担当者部署番号
        ['order_user_dep_name']: orderUserdepname, //発注担当者部署名
        ['order_user_email']: orderEmail, //発注担当者メールアドレス
        ['billing_user_flg']: reqBillingUser, //購入依頼者有無
        ['billing_user_id']: billingUsernumber, //購入依頼者番号
        ['billing_user_name']: billingUsername, //購入依頼者名
        ['billing_user_dep_id']: billingUserdepnumber, //購入依頼者部署番号
        ['billing_user_dep_name']: billingUserdepname, //購入依頼者部署名
        ['billing_company_flg']: reqBillingCompany, //仕入先有無
        ['billing_company_id']: billingCompanynumber, //仕入先番号
        ['billing_company_name_full']: billingCompanynameFull, //仕入先名称
        ['billing_company_name']: billingCompanyname, //仕入先名称(略)
        ['remark_on_order']: remarkOnOrder, //注文に関する備考
        ['delivery_office_id']: deliveryOfficeinfo.id.id, //納入先事業所番号
        ['delivery_office_name']: deliveryOfficeinfo.id.name, //納入先事業所名
        ['delivery_office_address_main']: deliveryOfficeinfo.id.address_main, //納入先事業所住所1
        ['delivery_office_address_sub']: deliveryOfficeinfo.id.address_sub, //納入先事業所住所2
        ['delivery_office_tell']: deliveryOfficeinfo.id.tell, //納入先事業所電話番号
        ['delivery_department']: deliveryDepartment, //納入先部署名
      }

      return updatedState
    })
  }, [
    orderUsernumber,
    orderEmail,
    orderUsername, //検索結果を反映させるため
    billingUsernumber,
    billingUsername, //検索結果を反映させるため
    billingCompanynumber,
    billingCompanyname, //検索結果を反映させるため
    reqBillingUser,
    reqBillingCompany,
    deliveryOfficeinfo.id,
    remarkOnOrder,
    deliveryDepartment,
  ])

  //発注者情報のセット
  const inputOrderUser = useCallback(async (e) => {
    if (!e.target.value) return
    const workerId = String(parseInt(e.target.value))
    // getWorkersRecordsByNumberは通信エラー時にundefinedを返すため空配列に寄せる
    // (そのままだと .length で例外になり、onBlurが無反応になる)
    const workerInfo = (await getWorkersRecordsByNumber(workerId)) || []
    if (workerInfo.length === 0) {
      setOrderUsernumber(e.target.value)
      setOrderUsername('')
      setOrderUserdepnumber('')
      setOrderUserdepname('')
      setOrderEmail('')
    } else {
      // マスタ側でフィールドが欠落していても例外にせず空文字に倒す
      // (途中で throw すると入力欄が中途半端に埋まったまま無言で止まる)
      const worker = workerInfo[0]
      setOrderUsernumber(worker.B178_id?.value ?? e.target.value)
      // 職場氏名(旧姓等)が登録されていればそちらを使う。
      // かつてここだけが通常氏名を直接参照しており、社員番号で検索したときだけ
      // 職場氏名が反映されなかった(2026-08の問い合わせ)。
      setOrderUsername(resolveWorkerName(worker))
      setOrderUserdepnumber(worker.B178_syozoku_cd?.value ?? '')
      setOrderUserdepname(worker.B178_syozoku_name?.value ?? '')
      setOrderEmail(worker.B178_gmail?.value ?? '')
    }
  }, [])
  //購入依頼者情報のセット-OnBlur時に発火
  const inputBillingUser = useCallback(async (e) => {
    if (!e.target.value) return
    const workerId = String(parseInt(e.target.value))
    // 発注担当者側と同じ理由でundefinedを空配列に寄せる
    const workerInfo = (await getWorkersRecordsByNumberA(workerId)) || []
    if (workerInfo.length === 0) {
      setBillingUsernumber(Number(e.target.value))
      setBillingUsername('')
      setBillingUserdepnumber('')
      setBillingUserdepname('')
    } else {
      // 購入依頼者マスタ(workersA)には職場氏名にあたるフィールドが存在しないため
      // A13_ansynm(氏名)をそのまま使う。発注担当者(workers)とは異なる点に注意。
      const worker = workerInfo[0]
      setBillingUsernumber(Number(worker.A13_ansycd?.value ?? e.target.value))
      setBillingUsername(worker.A13_ansynm?.value ?? '')
      setBillingUserdepnumber(worker.A13_msy070?.value ?? '')
      setBillingUserdepname(worker['A13_部署名']?.value ?? '')
    }
  }, [])
  //派遣・協力会社のセット
  const inputBillingCompany = useCallback(async (e) => {
    if (!e.target.value) return
    const companyId = String(parseInt(e.target.value))
    const companyInfo = await getSuppliersRecordsByNumber(companyId)
    if (companyInfo.length === 0) {
      setBillingCompanynumber(e.target.value)
      setBillingCompanyname('')
      setBillingCompanynameFull('')
    } else {
      setBillingCompanynumber(parseInt(companyInfo[0].A153_gasicd.value))
      setBillingCompanynameFull(companyInfo[0].A153_gasina.value)
      setBillingCompanyname(companyInfo[0].A153_gasinm.value)
    }
  }, [])
  // 発注担当者プリセット権限切れの警告モーダル
  const [
    showOrderUserUnauthorizedModal,
    setShowOrderUserUnauthorizedModal,
  ] = useState(false)
  const clearOrderUserForm = useCallback(() => {
    setOrderUsernumber('')
    setOrderUsername('')
    setOrderUserdepnumber('')
    setOrderUserdepname('')
    setOrderEmail('')
  }, [])
  // userInfo.order_email から発注担当者をプリセット。
  // ただし users コレクション上の現在の role が発注担当者として有効でない場合は
  // プリセットせず、モーダルで再選択を促す。
  useEffect(() => {
    let cancelled = false
    ;(async () => {
      if (!userInfo.order_email) return
      try {
        // 1. usersコレクションから現在の権限を確認
        const orderUserOnUsers = await getUserByEmail(userInfo.order_email)
        if (cancelled) return
        if (
          !orderUserOnUsers ||
          !isAuthorizedOrderUser(orderUserOnUsers.role)
        ) {
          // 発注担当者として無効 → クリアして警告
          clearOrderUserForm()
          setShowOrderUserUnauthorizedModal(true)
          return
        }
        // 2. workers(社員マスタ)から表示用情報を取得してプリセット
        const workerInfo = await getWorkerInfoByEmail(userInfo.order_email)
        if (cancelled || !workerInfo) return
        setOrderUsernumber(workerInfo.B178_id.value)
        setOrderUsername(resolveWorkerName(workerInfo))
        setOrderUserdepnumber(workerInfo.B178_syozoku_cd.value)
        setOrderUserdepname(workerInfo.B178_syozoku_name.value)
        setOrderEmail(workerInfo.B178_gmail.value)
      } catch (error) {
        console.error('発注担当者のプリセットに失敗しました:', error)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [userInfo.order_email, clearOrderUserForm])
  //納入部署のリストの生成
  const departmentsOnFirestore = useSelector(getDepartments)
  const [departments, setDepartments] = useState([])
  useEffect(() => {
    dispatch(fetchdepartments())
  }, [dispatch])
  useEffect(() => {
    const departmentList = departmentsOnFirestore
      .map((department) => {
        return {
          name: department.name,
          factoryName: department.base_name,
          id: department.name,
        }
      })
      .filter((department) =>
        department.factoryName.startsWith(deliveryOfficeinfo.id.name)
      )
    if (
      !(
        deliveryOfficeinfo.id.id === '51' ||
        deliveryOfficeinfo.id.id === 51 ||
        deliveryOfficeinfo.id.id === '50' ||
        deliveryOfficeinfo.id.id === 50
      )
    ) {
      departmentList.unshift({ name: '-', id: '-' })
    }
    setDepartments(departmentList)
  }, [departmentsOnFirestore, deliveryOfficeinfo])
  useEffect(() => {
    console.log('departments', departments, orderInfo, userInfo)
    if (departments.length > 0) {
      const matchingIndex = departments.findIndex((item) => {
        // console.log(item.id.name, orderInfo.order_base_name);
        return item.name.startsWith(orderInfo.order_department_name)
      })
      if (matchingIndex !== -1) {
        setDeliveryDepartment(departments[matchingIndex]?.id)
        setOrderInfo((prevState) => {
          const updatedState = {
            ...prevState,
            delivery_department: departments[matchingIndex]?.id,
          }
          return updatedState
        })
      } else {
        // ヒットしなかった場合、0番目のオブジェクトをセット
        setDeliveryDepartment(departments[0]?.id)
        setOrderInfo((prevState) => {
          const updatedState = {
            ...prevState,
            delivery_department: departments[0]?.id,
          }
          return updatedState
        })
      }
    }
  }, [departments])
  const handleDepartmentChange = (value) => {
    console.log(value, 'handleDepartmentChange')
    setDeliveryDepartment(value)
    setOrderInfo((prev) => {
      return { ...prev, delivery_department: value }
    })
  }
  //デバッグ用
  useEffect(() => {
    console.log('orderInfo', orderInfo, 'product', productsInCart)
  }, [productsInCart, orderInfo])
  //
  const { isValid: isDeductionValid } = useDeductionValidation(productsInCart)
  const { isApplied: isDeductionApplied } = useDeductionApplied(productsInCart)
  return (
    <section className="c-section-wrapin">
      <h2 className="u-text__headline">注文の確認</h2>
      <div className="p-grid__row">
        <div className={classes.detailBox}>
          <List>
            {productsInCart.length > 0 &&
              productsInCart.map((product) => (
                <CartListItem
                  product={product}
                  key={product.cartId}
                  updateProductItem={(newRemarks, newQuantity, newTotalPrice) =>
                    updateProductItem(
                      product.cartId,
                      newRemarks,
                      newQuantity,
                      newTotalPrice
                    )
                  }
                  isEnableRemarks={true}
                />
              ))}
          </List>
        </div>
        <div className={classes.orderBox}>
          <h2 className="u-text__medium__headline">注文詳細入力</h2>
          <div className={classes.searchWrapper}>
            <div className={classes.searchContents}>
              <TextInputName
                disabled={true}
                fullWidth={true}
                label={'発注部署'}
                multiline={false}
                required={true}
                onChange={undefined}
                name={''}
                minRows={1}
                value={`${orderInfo.order_base_name} ${orderInfo.order_department_name}`}
                onBlur={undefined}
                type={'text'}
              />
            </div>
            {(!orderInfo.order_base_name ||
              !orderInfo.order_department_name) && (
              <p className={classes.alertMessage}>
                発注部署が指定されていません
              </p>
            )}
          </div>
          <div className={classes.searchWrapper}>
            <div className={classes.searchContents}>
              <TextInputName
                fullWidth={true}
                label={
                  orderUsernumber
                    ? `発注担当者:${orderUsernumber} ${orderUsername}`
                    : '発注担当者No'
                }
                multiline={false}
                required={true}
                onChange={inputOrderInfo}
                name={'order_user_id'}
                minRows={1}
                value={orderInfo.order_user_id}
                onBlur={inputOrderUser}
                type={'text'}
              />
              <button
                className={classes.languageButton}
                onClick={handleOrderUserButtonClick}
              >
                <LanguageIcon />
              </button>
            </div>
            {(!orderUsername || !orderUserdepname || !orderEmail) && (
              <p className={classes.alertMessage}>
                {!orderEmail && orderUsername && orderUserdepname
                  ? '発注者がメールを持っていません'
                  : '発注者を指定してください'}
              </p>
            )}
          </div>
          <div className="module-spacer--extra-small" />
          {isUpperNormal(userInfo.role) ? (
            <SelectBoxForBillingUserCheck
              label={'購入依頼者'}
              options={reqBillingUsers}
              required={true}
              select={setReqBillingUser}
              value={reqBillingUser}
            />
          ) : (
            <TextInputName
              disabled={true}
              fullWidth={true}
              label={'購入依頼者'}
              multiline={false}
              required={true}
              onChange={undefined}
              name={''}
              minRows={1}
              value={reqBillingUser}
              onBlur={undefined}
              type={'text'}
            />
          )}

          {reqBillingUser === '有' && (
            <div className={classes.searchWrapper}>
              <div className={classes.searchContents}>
                <TextInputName
                  fullWidth={true}
                  label={
                    billingUsernumber
                      ? `購入依頼者:${billingUsernumber} ${billingUsername}`
                      : '購入依頼者No'
                  }
                  multiline={false}
                  required={true}
                  onChange={inputOrderInfo}
                  name={'billing_user_id'}
                  minRows={1}
                  value={billingUsernumber}
                  type={'number'}
                  onBlur={inputBillingUser}
                />
                <button
                  className={classes.languageButton}
                  onClick={handleBillingUserButtonClick}
                >
                  <LanguageIcon />
                </button>
              </div>
              {(!billingUsername || !billingUserdepname) && (
                <p className={classes.alertMessage}>購入者を指定してください</p>
              )}
            </div>
          )}
          <div className="module-spacer--extra-small" />
          {isUpperNormal(userInfo.role) ? (
            <SelectBoxForBillingUserCheck
              label={'派遣・協力会社'}
              options={reqBillingCompanies}
              required={true}
              select={setReqBillingCompany}
              value={reqBillingCompany}
            />
          ) : (
            <TextInputName
              disabled={true}
              fullWidth={true}
              label={'派遣・協力会社'}
              multiline={false}
              required={true}
              onChange={undefined}
              name={''}
              minRows={1}
              value={reqBillingCompany}
              onBlur={undefined}
              type={'text'}
            />
          )}
          {reqBillingCompany === '有' && (
            <div className={classes.searchWrapper}>
              <div className={classes.searchContents}>
                <TextInputName
                  fullWidth={true}
                  label={
                    billingCompanynumber
                      ? `派遣・協力会社:${billingCompanynumber} ${billingCompanyname}`
                      : '派遣・協力会社No'
                  }
                  multiline={false}
                  required={true}
                  onChange={inputOrderInfo}
                  name={'billing_company_id'}
                  minRows={1}
                  value={billingCompanynumber}
                  type={'number'}
                  onBlur={inputBillingCompany}
                />
                <button
                  className={classes.languageButton}
                  onClick={handleBillingCompanyButtonClick}
                >
                  <LanguageIcon />
                </button>
              </div>
              {(!billingCompanyname || !billingCompanynumber) && (
                <p className={classes.alertMessage}>会社を指定してください</p>
              )}
            </div>
          )}
          <div className="module-spacer--extra-extra-small" />
          {/* {reqBillingCompany === "無" && reqBillingUser === "無" && ( */}
          {/* <TextInputName
            fullWidth={true}
            label={"注文に関する備考"}
            multiline={false}
            required={true}
            onChange={inputOrderInfo}
            name={"remark_on_order"}
            minRows={1}
            value={orderInfo.remark_on_order}
            type={"text"}
          /> */}
          {/* )} */}
          <div className="module-spacer--extra-extra-small" />
          {/* <TextInputName
                    fullWidth={true} label={"納入先事業所"} multiline={false} required={true}
                    onChange={inputOrderInfo}  name={"deliveryOffice"} minRows={1} value={orderInfo.deliveryOffice} type={"number"} 
              /> */}
          <SelectBoxForOffice
            label={'納入先事業所'}
            options={deliveryOffices}
            required={true}
            select={setDeliveryOfficeinfo}
            value={deliveryOfficeinfo.id.id}
          />
          <div className={classes.selectBox}>
            <SelectBoxForDepartment
              label={'納入先部署'}
              options={departments}
              required={true}
              select={handleDepartmentChange}
              value={orderInfo.delivery_department}
            />
          </div>
          {/* <TextInputName
            fullWidth={true}
            label={"納入先部署"}
            multiline={false}
            required={false}
            onChange={(e) => {
              setDeliveryDepartment(e.target.value);
              setOrderInfo((prev) => {
                return { ...prev, delivery_department: e.target.value };
              });
            }}
            name={"delivery_department"}
            minRows={1}
            value={orderInfo.delivery_department}
            type={"text"}
          /> */}
          {!orderInfo.delivery_department && (
            <div className={classes.alertMessage}>
              本社工場、本巣工場は必須です
            </div>
          )}

          {/* <div className="module-spacer--small"/> */}
          <div className="module-spacer--extra-extra-small" />
          <h2 className="u-text__medium__headline">注文金額</h2>
          <TextDetail
            label={'商品合計'}
            value={'¥' + subtotal.toLocaleString()}
          />
          <TextDetail
            label={'本人負担'}
            color={isDeductionApplied ? 'red' : undefined}
            value={'¥' + deductionSubtotal.toLocaleString()}
          />
          {/* <TextDetail label={"消費税"} value={"¥" + tax.toLocaleString()} /> */}
          {/* <TextDetail label={"送料"} value={"¥" + shippingFee.toLocaleString()}/> */}
          <Divider />
          {/* <div className="module-spacer--extra-extra-small" />
          <TextDetail
            label={"合計(税込)"}
            value={"¥" + total.toLocaleString()}
          />
          <TextDetail
            label={"本人負担(税込)"}
            value={"¥" + deductionTotal.toLocaleString()}
          /> */}
          <div className="module-spacer--extra-extra-small" />
          <PrimaryButton
            label={'注文を確定する'}
            onClick={order}
            disabled={!isDeductionValid || isSubmitting}
          />
        </div>
      </div>
      {showSelectOrderUser && (
        <SelectOrderUser
          username={orderUsername}
          setUsername={setOrderUsername}
          usernumber={orderUsernumber}
          setUsernumber={setOrderUsernumber}
          userdepnumber={orderUserdepnumber}
          setUserdepnumber={setOrderUserdepnumber}
          userdepname={orderUserdepname}
          setUserdepname={setOrderUserdepname}
          setShowSelectUser={setShowSelectOrderUser}
          email={orderEmail}
          setEmail={setOrderEmail}
        />
      )}
      {showSelectBillingUser && (
        <SelectWorkerA
          username={billingUsername}
          setUsername={setBillingUsername}
          usernumber={billingUsernumber}
          setUsernumber={setBillingUsernumber}
          userdepnumber={billingUserdepnumber}
          setUserdepnumber={setBillingUserdepnumber}
          userdepname={billingUserdepname}
          setUserdepname={setBillingUserdepname}
          setShowSelectUser={setShowSelectBillingUser}
        />
      )}
      {showSelectBillingCompany && (
        <SelectSupplier
          companynumber={billingCompanynumber}
          setCompanynumber={setBillingCompanynumber}
          companyname={billingCompanyname}
          setCompanyname={setBillingCompanyname}
          companynamefull={billingCompanynameFull}
          setCompanynamefull={setBillingCompanynameFull}
          setShowSelectBillingCompany={setShowSelectBillingCompany}
        />
      )}
      {showOrderUserUnauthorizedModal && (
        <JumpModal
          title={'発注担当者の確認'}
          message={
            '以前に指定された発注担当者は、現在は発注担当者の権限を保有していません。お手数ですが発注担当者を選び直して注文を確定してください。'
          }
          setIsShow={setShowOrderUserUnauthorizedModal}
          onExec={() => {
            setShowOrderUserUnauthorizedModal(false)
            setShowSelectOrderUser(true)
          }}
          buttonLabel={'発注担当者を選択'}
        />
      )}
    </section>
  )
}

export default OrderConfirm

/**
 * categoryMaster=[
 * {cid: "C003", limit: 1, deducation: 1},{cid: "C002", limit: 4, deducation: 2}]
 * categoryCounts=[
 * {category_id: "C003", quantity: 1},{category_id: "C002", count: 3}]
 *
 * 上記のような配列categoryMasterとcategoryCountsを受け取り、新たに配列を生成したい
 * categoryMasterのcidとcategoryCountsのcategory_idが一致する場合、
 * categoryMasterのlimitの数値からcategoryCountsのquantityの数値を引いた数値をセットした状態のcategoryMasterの配列を生成したい。
 *
 */
